// eslint-disable-next-line no-restricted-imports
import { LegalClientsListItemFragment } from 'api/generated/graphql';
import { LegalClientsListItemData } from 'api/types/data';

import { parseLegalClientAccountStatus } from '../legal/parseEntity/parseLegalClientAccountStatus';
import { parseLegalClientOnboardingStatus } from '../legal/parseEntity/parseLegalClientOnboardingStatus';
import { parseOboardingData } from '../parseOboardingData';

export const parseLegalClientsListItemData = (
  clients: LegalClientsListItemFragment[]
): LegalClientsListItemData[] =>
  clients.map((client) => ({
    id: client.id,
    fullName: client.fullName ?? '',
    shortName: client.shortName ?? undefined,

    email: client.representative?.email ?? undefined,
    phone: client.representative?.phoneNumber ?? undefined,

    code: client.code ?? undefined,
    centralDepositoryAccountNumber:
      client.centralDepositoryAccountNumber ?? undefined,
    personalAccountNumber: client.personalAccount?.number ?? undefined,
    personalAccountOpeningDate: client.personalAccount?.openingDate
      ? new Date(client.personalAccount.openingDate)
      : undefined,

    onboardingStatus: parseLegalClientOnboardingStatus(client.onboardingStatus),
    accountStatus: parseLegalClientAccountStatus(client.accountStatus),

    countryRegistration: client.legalAddress?.country.name,
    location: client.actualAddress?.country.name,

    onboarding: parseOboardingData(client.representative?.onboarding),

    lastSessionDate: client.representative?.user.lastAuthSessionLog?.updatedAt
      ? new Date(client.representative.user.lastAuthSessionLog?.updatedAt)
      : undefined,
  }));
